export const SCHEDULE_UPCOMING_PAYMENT_DAYS = 7;
export const UPCOMING_CHARGE_DAYS = 4;

export const MAX_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT = 10_000_00; /* ¢ */
export const MIN_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT = 50; /* ¢ */

/**
 * Mangopay minimum deposit amount in cents (0.10€)
 * This is a requirement from Mangopay for all deposits
 */
export const MANGOPAY_MIN_DEPOSIT_AMOUNT_CENTS = 10;
export const MANGOPAY_MAX_DEPOSIT_AMOUNT_CENTS = 250000; /* ¢ */
